


// const dReviews = store.getState(dailyReviews.pay);
export const dailyReviews = [
    {
        title: 'Members',
        // 'amount': dReviews.transactions && dReviews.transactions,
        'icon': 'members'
    },
    {
        title: 'Sliders',
        'amount': '₦12,000', 
        'icon': 'sliders'
    },
    {
        title: 'payments',
        'amount': '₦12,000', 
        'icon': 'payments'
    },
    {
        title: 'Events',
        // 'amount': dReviews.transactions && dReviews.transactions,
        'icon': 'events'
    },
    {
        title: 'Gallery',
        // 'amount': '₦'+dReviews.salesAmount && dReviews.salesAmount, 
        'icon': 'gallery'
    },
    {
        title: 'Highlights',
        'amount': '₦12,000', 
        'icon': 'highlights'
    },
    {
        title: 'Last Message',
        'message': "We appreciate the innovating initiative you all have brought to Bida.",
        'icon': 'notification'
    },

];

export const overallReviews = [
    
    {
        title: 'Users',
        'amount': 12,
        icon: 'users' 
    },
    {
        title: 'Total Sales',
        'amount': '₦13,000',
        icon: 'transaction'
    },
    {
        title: 'Total Returned Amount',
        'amount': '₦103,000,000',
        icon: 'sales' 
    },
    {
        title: 'Total Profit',
        'amount': '₦1,200,000', 
        icon: 'profit'
    },
    {
        title: 'Total Store Items',
        'amount': '₦120,000', 
        icon: 'store'
    },
];
